import Viewer from "../Viewer";
import { useEffect, useMemo } from "react";
import { Route, Routes  } from 'react-router-dom'
import { configSet } from "../../reducers/auth";
import { useAppDispatch } from "../../store/store";
import { IConfig } from "../../model/IConfig";
import AppLayout from "../AppLayout/AppLayout";
import { useTypedSelector } from "../../reducers";
import LandingPage from "../LandingPage/LandingPage";
import MikeSnackbar from "../mike-snackbar/MikeSnackbar";
import { errorCleared, messageCleared } from "../../reducers/toast";
import Impressum from "../Imprint/Imprint";
import DataProtection from "../DataProtection/DataProtection";
import Typography from '@mui/material/Typography';
import mikeSharedTheme from "../../styles/mikeSharedTheme";

interface IProps {
  config: IConfig;
}

function App(props: IProps) {
  const {config} = props;
  
  const user = useTypedSelector((state) => state.auth.user);
  const {message, error} = useTypedSelector((state) => state.toast);
  const dispatch = useAppDispatch();

  const isAuthenticated  = useMemo(() => {   
    return user !== null
  },[user]) 

  useEffect(
    () => {  
      if (config) {      
        dispatch(configSet(config))        
      }
    },
    [dispatch, config],
  );

  const onRemoveError = () => {
    dispatch(errorCleared())
  }

  const onCloseMessage  = () => {
    dispatch(messageCleared())
  }

  const showText = (lines: Array<string>) => {
    return (
      <div>
        {lines.map((line: string, i: number) => (
          <Typography color={mikeSharedTheme.palette.primary.contrastText} variant="body2" key={i}>
            {line}
          </Typography>
        ))}
      </div>
    )
  }


  return  (  
    <>
     <MikeSnackbar
        open={error.length > 0}
        mikeSnackbarType={'error'}
        message={showText(error)}
        action={'OK'}
        mikeOnAction={onRemoveError}
        onClose={onRemoveError}
        autoHideDuration={null}
    />

    <MikeSnackbar
      open={message.length > 0}
      mikeSnackbarType={'regular'}
      message={showText(message)}
      action={'OK'}
      mikeOnAction={onCloseMessage}
      onClose={onCloseMessage}
    />
    <AppLayout>   
      <Routes>
        <Route path='/impressum' element={<Impressum/>} />
        <Route path='/datenschutz' element={<DataProtection/>} />
        <Route path='/' element={isAuthenticated ?  <Viewer/> :  <LandingPage/>} />  
      </Routes>
    </AppLayout>
    </> 
    
  ) 
  
}

export default App
